import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMove = () => {
  return (
    <g>
      <g fillRule="evenodd">
        <path d="M2 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 012 6.54zM2 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 012 .085zM9 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 019 6.54zM9 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 019 .085z" />
      </g>
    </g>
  );
};

export default withIcon(IconMove);
